import {
	getLoginStart,
	getLoginSuccess,
	getLoginError,
	getEmailStart,
	getEmailError,
	getTerms,
	getPolicy,
} from './slices'
import { getEmailSuccess } from '../../components/Modal/slices'
import { push } from 'connected-react-router'
import Api from 'utils/api'
import { setDataFromJWTToken } from '../../store/root-slices'
import { showPopup } from 'components/Modal/slices'
import { setToken } from '../../utils/auth'

export const getLogin = ({
	email,
	orderId,
	language,
	shopId,
	managerUsername,
}) => async (dispatch) => {
	try {
		dispatch(getLoginStart())
		Api.get(
			`/login?email=${email}&language=${language}&shopId=${shopId}${
				orderId ? `&orderId=${orderId}` : ''
			}${managerUsername ? `&managerUsername=${managerUsername}` : ''}`
		)
			.then((res) => {
				setToken(JSON.stringify(res))
				dispatch(getLoginSuccess(res))
				setTimeout(() => {
					dispatch(push('/orders'))
				}, 0)
			})
			.catch((error) => {
				dispatch(showPopup(error))
			})
	} catch (error) {
		dispatch(getLoginError())
	}
}
export const getLoginToken = (token) => (dispatch) => {
	try {
		dispatch(setDataFromJWTToken(token))
	} catch (error) {
		dispatch(getLoginError())
	}
}

export const getEmail = (data) => async (dispatch) => {
	try {
		dispatch(getEmailStart())
		Api.post('/email/login', data)
			.then((res) => {
				dispatch(getEmailSuccess(res))
				dispatch(getEmailError())
			})
			.catch((error) => {
				dispatch(showPopup(error))
			})
	} catch (error) {
		dispatch(getEmailError())
	}
}

/**
 * getTermsReq {Function}
 * @description - send request to the server to get terms data. Dispatch event to set terms data into login reducer
 *
 * */
export const getTermsReq = (shopId, locale) => async (dispatch) => {
	try {
		Api.get(`faqs/${shopId}/language/${locale}/terms`)
			.then((res) => {
				dispatch(getTerms(res))
			})
			.catch((error) => {
				dispatch(showPopup(error))
			})
	} catch (error) {
		dispatch(getLoginError())
	}
}

/**
 * getPolicyReq {Function}
 * @description - send request to the server to get policy data. Dispatch event to set policy data into Main reducer
 *
 * */
export const getPolicyReq = (shopId, locale) => async (dispatch) => {
	try {
		Api.get(
			`/privacy-policy/latest?language=${locale}&shopId=${shopId}`
		).then((res) => {
			dispatch(getPolicy(res))
		})
	} catch (error) {
		dispatch(getLoginError())
	}
}
